import { render, staticRenderFns } from "./pos-access-control-events.vue?vue&type=template&id=d9523e98&scoped=true&"
import script from "./pos-access-control-events.vue?vue&type=script&lang=ts&"
export * from "./pos-access-control-events.vue?vue&type=script&lang=ts&"
import style0 from "./pos-access-control-events.vue?vue&type=style&index=0&id=d9523e98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9523e98",
  null
  
)

export default component.exports